export const WCA_OIDC_ISSUER = process.env.OIDC_ISSUER!;
export const WCA_OIDC_CLIENT_ID = process.env.OIDC_CLIENT_ID!;
export const WCA_OIDC_CLIENT_SECRET = process.env.OIDC_CLIENT_SECRET!;
